import { render } from "./UserMfaRegisterOffcanvas.vue?vue&type=template&id=09c15976&scoped=true"
import script from "./UserMfaRegisterOffcanvas.vue?vue&type=script&lang=js"
export * from "./UserMfaRegisterOffcanvas.vue?vue&type=script&lang=js"

import "./UserMfaRegisterOffcanvas.vue?vue&type=style&index=0&id=09c15976&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c15976"]])

export default __exports__